import { Button } from "@chakra-ui/react";

import { StepDetailsBaseProps } from "../../models/StepDetailsBaseProps";
import { StepStateModel } from "../../models/StepModel";

 
export const PortfolioInfoStep = (props: StepDetailsBaseProps) => {
    const {
        colorScheme = 'blue', 
        className,
        style,
        children,
        saveActiveStepState,
        stepsSavedState,
        title,
        description,
        stepIdx,
        selectedStepOptionValue, // the value of the selected option
        stepOptions,
        setIsStepValid,
    } = props;

    const stepState: StepStateModel = { 
        stepIdx,
        mainInfo: {
            name: "OLGA TEST",
            bookId: 1,
            description: "OLGA TEST Poprtfolio description",
            isMaster: false,
        },
    };


    const renderStepContent = () =>  {
        console.log({...props});

        return (
            <>
                <h4>{ `${props.title}` }</h4>

                <>
                    <p>Input:</p>
                    <ul>
                        <li>Portfolio Name (textbox - required): OLGA TEST</li>
                        <li>Master (checkbox - optional): false</li>
                        <li>Portfolio Description (textarea - optional): OLGA TEST Poprtfolio description</li>
                        <li>Book Name (dropdown - defaults to current book): 1</li>
                    </ul>
                </>
                
                <Button onClick={() => {
                    saveActiveStepState(stepIdx, stepState); 
                    setIsStepValid(true);
                    }}
                    >Simulating all required fields are entered and valid</Button>

            </>
        );
    }

    return renderStepContent()
 
}


